import type { Locale } from '@packages/config';

const domain =
  typeof window !== 'undefined'
    ? window.location.host
    : process.env.SERVER_HOST || 'platform.empirie.dev';

export const getNavigationDataEndpoint = (
  clientId: string,
  channel: string,
  locale: Locale,
  sliced: boolean,
): string => {
  const environment =
    domain.includes('localhost') || domain.includes('.dev') || domain.includes('emma.lan')
      ? 'dev'
      : 'cloud';
  const isFr = locale.includes('fr') ? '_fr' : '';
  const formattedClientID = clientId.toLowerCase();
  const version = '0';
  const slicedVersion = sliced ? '_sliced' : '';

  return `https://storage.googleapis.com/emp-search-nav/${environment}/${formattedClientID}_${channel}${isFr}_${version}${slicedVersion}.json`;
};
